import * as React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import get from 'lodash/get';
import styles from './RichNavigation.css';
import getImageUrl from 'utils/getImageUrl';
import SimpleImage from 'components/Common/Image/SimpleImage';
import TrackableComponent, { ImpressionEvent } from 'components/TrackableComponent/TrackableComponent';
import NavigationItem from './NavigationItem';
import { RichNavigationViewTypes } from 'constants/viewTypes';
class RichNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.setRef = (container) => {
            this.props.innerRef(container);
        };
    }
    getImage(title, value) {
        const imageUrl = getImageUrl(get(value, ['image', 'dynamicImageUrl']), '128', '100');
        return (imageUrl && (<div className={styles['image']}>
					<SimpleImage src={imageUrl} alt={title} size={64} lazyLoadEnable={false}/>
				</div>));
    }
    render() {
        const { containerClassName, navContainerClassName = '', navigationBarMenu } = this.props;
        return (<div className={navContainerClassName}>
				<div className={cx(styles['container'], containerClassName)} ref={this.setRef}>
					<div className={styles['list']}>
						{navigationBarMenu &&
            navigationBarMenu.map((item, k) => {
                return <NavigationItem key={k} item={item} wid={this.props.wid} isTextOnly={this.props.isTextOnly}/>;
            })}
					</div>
				</div>
			</div>);
    }
}
const RichNavigationWidget = TrackableComponent(RichNavigation, ImpressionEvent.DWI, props => {
    const widgetTracking = get(props, 'widget.tracking');
    widgetTracking['position'] = widgetTracking['position'] || 1;
    return widgetTracking;
});
export class RichNavContainer extends React.Component {
    constructor() {
        super(...arguments);
        this.getNavigationTree = (props) => {
            const data = get(props, 'widget.data');
            return get(data, 'renderableComponents') || [];
        };
    }
    render() {
        const wid = get(this.props, 'widget.tracking.widgetKey') || '';
        const data = this.getNavigationTree(this.props);
        return data && data.length > 0 && <RichNavigationWidget {...this.props} navigationBarMenu={data} wid={wid}/>;
    }
}
function mapStateToProps(state) {
    const pageSlots = get(state, 'pageDataV4.page.data.ROOT');
    const richNavigationWidget = pageSlots.find(slot => slot.slotType === SlotType.WIDGET &&
        get(slot, 'widget.type') === WidgetTypeV4.RICH_NAVIGATION &&
        get(slot, 'widget.viewType') === RichNavigationViewTypes.NAV_EXPANDABLE);
    return {
        widget: richNavigationWidget && richNavigationWidget.widget
    };
}
export default connect(mapStateToProps, {})(RichNavContainer);
